<template>
    <div id="app" class="bg-base-200">
        <meta name="referrer" content="no-referrer">
        <meta name="mobile-web-app-capable" content="yes">
        <meta name="apple-mobile-web-app-capable" content="yes">
        <meta name="apple-mobile-web-app-status-bar-style" content="black">
        <!-- <link href="./output.css" rel="stylesheet"> -->
        <magic-menu v-if="$route.name !== 'login'"></magic-menu>
        <div v-else>
            <login></login>
        </div>
    </div>
</template>

<script>
import magicMenu from '@/components/base/magicMenu'
import Login from '@/views/user/login'
import { getApiBaseUrl, isAppMode } from '@/utils/apiConfig'
// 动态导入stagewise依赖，避免在生产环境中打包

export default {
    name: 'app',
    components: {
        magicMenu,
        Login
    },
    data() {
        return {
            menuList: [],
            StagewiseToolbar: null,
            stagewiseConfig: null
        }
    },
    computed: {
        isDevelopment() {
            return process.env.NODE_ENV === 'development'
        }
    },
    async mounted() {
        try {
            await this.$store.dispatch('initializePlayer')
        } catch (error) {
            console.warn('初始化播放器失败:', error)
        }
    },
    created() {
        // todo test
        window.projectVersion = '20260101'
        window.projectVersionNum = '2.6.7'

        // 应用模式下检查服务器地址配置
        if (isAppMode()) {
            const apiBaseUrl = getApiBaseUrl()
            console.log('App 模式启动, API 地址:', apiBaseUrl)

            // 如果没有配置服务器地址,跳转到登录页
            if (!apiBaseUrl && this.$route.name !== 'login') {
                console.log('未配置服务器地址,跳转到登录页')
                this.$router.push({ name: 'login' })
            }
        }
    },
}
</script>
<style>
.toggle:checked {
    @apply shadow-lg;
}
::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(255, 0, 0, .4)
}

::-webkit-scrollbar {
    width: 6px;
    height: 8px;
    background-color: rgba(255, 255, 255, .07)
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: rgba(11, 54, 106, .52);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .5)
}

::-webkit-scrollbar-thumb:window-inactive {
    background-color: rgba(255, 255, 255, .07)
}

.h-screen-header {
    height: calc(100vh - 85px);
}

.h-screen-index {
    height: calc(100vh - 70px);
}

.h-screen-header-tree {
    height: calc(100vh - 88px);
}

@media (max-width: 768px) {
    .h-screen-header {
        height: calc(100vh - 60px);
    }
    .h-screen-index {
    height: calc(100vh - 60px);
    }
    .h-screen-header-tree {
        height: calc(100vh - 60px);
    }
}




.w-screen-sidebar {
    width: calc(100vw - 240px);
}

.drawer-side {
    z-index: 10 !important;
}
</style>
